/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {combineReducers} from 'redux';
import jobCreate from '@ion/applications/src/components/jobs/state';
import globalSearch from '@ion/applications/src/globalsearch/state';
import notificationsPanel from '@ion/applications/src/notifications/state';
import adminGroups from '@ion/applications/src/pages/admin/accounts/state';
import adminAssets from '@ion/applications/src/pages/admin/assets/state';
import groups from '@ion/applications/src/pages/admin/groups/state';
import adminNotifications from '@ion/applications/src/pages/admin/notifications/state';
import adminRoles from '@ion/applications/src/pages/admin/roles/state';
import adminUsers from '@ion/applications/src/pages/admin/users/state';
import notifications from '@ion/applications/src/pages/alertsNotifications/state';
import applicationDashboard from '@ion/applications/src/pages/dashboard/state';
import devices from '@ion/applications/src/pages/devices/state';
import jobStatus from '@ion/applications/src/pages/jobstatus/state';
import applicationIds from '@ion/applications/src/pages/manufacturing/applicationIds/state';
import devicePartNumbers from '@ion/applications/src/pages/manufacturing/devicePartNumbers/state';
import manufacturedDevices from '@ion/applications/src/pages/manufacturing/devices/state';
import inventory from '@ion/applications/src/pages/manufacturing/inventory/state';
import shipments from '@ion/applications/src/pages/manufacturing/shipments/state';
import reports from '@ion/applications/src/pages/reports/state';
import notificationType from '@ion/applications/src/pages/systemconfig/notification-type/state';
import importer from '@ion/applications/src/store/reducers/importer';
import dialogs from '@ion/features/src/dialogs/state';
import dashboard from '@ion/ion-ctc-admin/src/routes/dashboard/state';
import adminAEMPConfig from './admin-aempconfig';
import adminApplications from './admin-applications';
import deviceConfigs from './admin-deviceconfigs';
import pegBehaviors from './admin-pegbehaviors';
import pegLabels from './admin-peglabels';
import devicefiles from './devicefiles';
import devicetypes from './devicetypes';
import downloadjobs from './downloadjobs';
import errors from './errors';
import exporter from './exporter';
import globalGroup from './global-group-chooser';
import initialization from './initialization';
import jobsearchengine from './jobsearchengine';
import keyfileBuilder from './keyfileBuilder';
import login from './login';
import nav from './nav';
import userPrompt from './user-prompt';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export type {ApplicationState} from '@/types/redux';

/**
 * Defines the root reducer which is a composite of all application specific
 * reducers via combineReducers.
 */
const rootReducer = combineReducers({
  initialization,
  errors,
  login,
  globalGroup,
  globalSearch,
  nav,
  jobCreate,
  dashboard,
  applicationDashboard,
  adminApplications,
  deviceConfigs,
  pegLabels,
  pegBehaviors,
  adminGroups,
  notifications,
  adminAssets,
  devicefiles,
  downloadjobs,
  adminAEMPConfig,
  devices,
  adminNotifications,
  notificationType,
  adminRoles,
  devicetypes,
  userPrompt,
  exporter,
  adminUsers,
  importer,
  notificationsPanel,
  groups,
  reports,
  jobStatus,
  dialogs,
  keyfileBuilder,
  inventory,
  applicationIds,
  devicePartNumbers,
  manufacturedDevices,
  shipments,
  jobsearchengine
});
export default rootReducer;
